import React from "react";
import { motion } from "framer-motion";

export const SectionHeading = ({ index, label, title, description, testId }) => {
  return (
    <div className="mb-14" data-testid={testId}>
      <motion.div
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="flex items-center gap-3 mb-4"
      >
        <span className="font-mono text-[11px] tracking-[0.3em] text-cyan-400">
          {index}
        </span>
        <span className="h-px flex-1 max-w-[120px] bg-gradient-to-r from-cyan-400/40 to-transparent" />
        <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-slate-500">
          {label}
        </span>
      </motion.div>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.8, delay: 0.05, ease: [0.22, 1, 0.36, 1] }}
        className="font-display text-4xl sm:text-5xl md:text-6xl tracking-tighter font-light text-white"
      >
        {title}
      </motion.h2>
      {description && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, delay: 0.12 }}
          className="mt-4 max-w-2xl text-slate-400 leading-relaxed"
        >
          {description}
        </motion.p>
      )}
    </div>
  );
};

export const Section = ({ id, children, className = "" }) => (
  <section
    id={id}
    className={`relative py-24 md:py-32 px-5 md:px-10 ${className}`}
    data-testid={`section-${id}`}
  >
    <div className="max-w-6xl mx-auto">{children}</div>
  </section>
);
